import React from 'react'

const Loaders = () => {
    return (
       <div className='reverse-spinner'></div>
    )

}

export default Loaders;